import { BaseButton } from '../styles/ButtonStyles';
import { InputText } from '../styles/TextStyles';
import styled from 'styled-components';
import { useEffect, useState } from 'react';
import {
    FlexWrapper,
    FlexWrapperCenter,
    GapView,
} from '../styles/WrapperStyles';

import aisleLogin1 from '../assests/aisle_logo_login_s.png';
import aisleLogin2 from '../assests/aisle_logo_login_u.png';
import arikeLogin1 from '../assests/arike_login_s.png';
import arikeLogin2 from '../assests/arike_login_u.png';
import anbeLogin1 from '../assests/anbe_login1.png';
import anbe_login2 from '../assests/anbe_login2.png';
// import heydil_login1 from '../assests/heydil_login1.png';
// import heydil_login2 from '../assests/heydil_login2.png';
// import jalebi_login1 from '../assests/jalebi_login1.png';
// import jalebi_login2 from '../assests/jalebi_login2.png';
import neene_login1 from '../assests/neene_login1.png';
import neene_login2 from '../assests/neene_login2.png';
import neetho_login1 from '../assests/neetho_login1.png';
import neetho_login2 from '../assests/neetho_login2.png';
import urls from '../api/urls.json'
import Loader from './Loader';
import CustomError from './Error';
import { useNavigate } from 'react-router-dom';
import { authorizedHttpPost, unauthorizedHttpPost } from '../api/httpCalls';
import BarCode from './modals/BarcodeModal';
import { offlineEventAccessLevel } from '../access_levels';

const LoginInput = styled(InputText)``;
const LoginButton = styled(BaseButton)`
  margin-top: 20px;
  margin-left: 110px
`;

const InputParent = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: center;
`;

const CapsWarning = styled.div`
  color: #e53935;
  font-family: 'Gilory-Semi';
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  margin-top: 6px;
`;

const LoginWrapper = styled.div`
  margin: auto;
  width: 90%; /* Adjust the width as needed for responsiveness */
  max-width: 400px; /* Set a maximum width for larger screens */
  margin-top: 150px;
`;

const TopImage = styled.img`
  margin: auto;
  cursor: pointer;
  width: 100%; /* Ensure the image scales with its container */
  max-width: 200px; /* Set a maximum width for larger screens */
`;

const initialState = {
    isLoading: false,
    email: '',
    password: '',
    appName: 'Aisle',
    isLoggedIn: false,
    otp: '',
    otp_verification_passed: false
};

if (localStorage.getItem('appName') === null) {
    localStorage.setItem('appName', 'Aisle');
}

const authenticatedLandingPath = () => (
    localStorage.getItem('accessLevel') === offlineEventAccessLevel
        ? '/event'
        : '/people'
);

function Login() {
    const [isFullyAuthenticated, setIsFullyAuthenticated] = useState(false);
    const navigate = useNavigate();
    const [state, setState] = useState(initialState);
    const [errorMessage, setErrorMessage] = useState('');
    const [showBarcode, setShowBarcode] = useState(false);
    const [barCodeUrl, setBarCodeUrl] = useState('');
    const [isCapsLockOn, setIsCapsLockOn] = useState(false);

    const navigateAfterOtp = () => {
        const savedRedirectUrl = sessionStorage.getItem('redirectUrl');
        const destination = localStorage.getItem('accessLevel') === offlineEventAccessLevel
            ? '/event'
            : (savedRedirectUrl || authenticatedLandingPath());

        sessionStorage.removeItem('redirectUrl');
        navigate(destination);
    };

    useEffect(() => {
        setState({ ...state, appName: localStorage.getItem('appName') });
        if (localStorage.getItem('authToken') && localStorage.getItem('verificationPassed')) {
            window.location.href = authenticatedLandingPath();
        } else {
            setIsFullyAuthenticated(true);
        }
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setState({ ...state, [name]: value });
    };

    const handleAppNameChange = (e) => {
        const appName = e.target.alt;
        setState({ ...state, appName: appName });
        localStorage.setItem('appName', appName);
    };

    const handleCapsLockState = (e) => {
        if (typeof e.getModifierState === 'function') {
            setIsCapsLockOn(e.getModifierState('CapsLock'));
        }
    };

    const loginWithCredentials = async (e) => {
        setState({ ...state, isLoading: true });
        e.preventDefault();
        setErrorMessage('');
        const { email, password } = state;
        if (!email || !password) {
            setErrorMessage('Please enter email and password.');
            return;
        }
        const params = { email: email, encrypted_password: password };
        let response = await unauthorizedHttpPost(urls.LOGIN, params)
        localStorage.removeItem('isLoggedIn');
        localStorage.removeItem('authToken');
        localStorage.removeItem('accessLevel');
        setState({ ...state, isLoggedIn: false });
        if (response.status) {
            if (response.data.qr_code_url) {
                setBarCodeUrl(response.data.qr_code_url);
                setShowBarcode(true);
                localStorage.setItem('authToken', response.data.auth_token);
                localStorage.setItem('accessLevel', response.data.access_level);
            } else {
                if (response.data.auth_token !== null) {
                    setErrorMessage('');
                    localStorage.setItem('authToken', response.data.auth_token);
                    localStorage.setItem('accessLevel', response.data.access_level);
                    localStorage.setItem('isLoggedIn', true);
                    setState({ ...state, isLoggedIn: true });
                } else if (response.status && response.data.auth_token === null) {
                    setErrorMessage("Invalid email or password.");
                    setState({ ...state, isLoggedIn: false });
                } else {
                    setErrorMessage(response.data.message);
                }
            }
        }
        setState({ ...state, isLoading: false });
    };


    const handleOtpSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage('');
        if (!state.otp) {
            setErrorMessage('Please enter OTP.');
            return;
        }
        setState({ ...state, isLoading: true });
        let response = await authorizedHttpPost(urls.POST_AUTHENTICATE_PASSCODE, { otp: state.otp })
        if (response.status && response.data.otp_verification_passed) {
            localStorage.setItem('verificationPassed', true);
            localStorage.removeItem('isLoggedIn');
            navigateAfterOtp();
        } else if (response.status && !response.data.otp_verification_passed) {
            setErrorMessage("Invalid OTP.");
        } else {
            setErrorMessage(response.data.message);
        }
        setState({ ...state, isLoading: false });
    };

    const passCodeClicked = async (code) => {
        setState({ ...state, isLoading: true });
        setState({ ...state, otp: code });
        if (!code) {
            alert('Please enter OTP.');
            return;
        }
        let response = await authorizedHttpPost(urls.POST_AUTHENTICATE_PASSCODE, { otp: code })
        if (response.status && response.data.otp_verification_passed) {
            localStorage.setItem('verificationPassed', true);
            localStorage.removeItem('isLoggedIn');
            navigateAfterOtp();
        } else if (response.status && !response.data.otp_verification_passed) {
            setErrorMessage("Invalid OTP.");
        } else {
            setErrorMessage(response.data.message);
        }
        setState({ ...state, isLoading: false });
    }

    return (
        <>
            {showBarcode && <BarCode url={barCodeUrl} closeModal={() => setShowBarcode(false)} passCodeClicked={passCodeClicked} />}
            {state.isLoading && <Loader loading={state.isLoading} />}
            {
                isFullyAuthenticated ? (
                    <LoginWrapper>
                        <FlexWrapperCenter>
                            <FlexWrapper>
                                <TopImage
                                    src={state.appName === 'Aisle' ? aisleLogin1 : aisleLogin2}
                                    alt="Aisle"
                                    onClick={handleAppNameChange}
                                />
                                <GapView width="30px" />
                                <TopImage
                                    src={state.appName === 'Arike' ? arikeLogin1 : arikeLogin2}
                                    alt="Arike"
                                    onClick={handleAppNameChange}
                                />
                            </FlexWrapper>
                        </FlexWrapperCenter>
                        <GapView height="20px" />
                        <FlexWrapperCenter>
                            <FlexWrapper>
                                <TopImage
                                    src={state.appName === 'Anbe' ? anbeLogin1 : anbe_login2}
                                    alt="Anbe"
                                    onClick={handleAppNameChange}
                                />
                                <GapView width="30px" />
                                {/* <TopImage
                            src={state.appName === 'HeyDil' ? heydil_login1 : heydil_login2}
                            alt="HeyDil"
                            onClick={handleAppNameChange}
                        /> */}
                            </FlexWrapper>
                        </FlexWrapperCenter>
                        <GapView height="20px" />
                        <FlexWrapperCenter>
                            <FlexWrapper>
                                <TopImage
                                    src={state.appName === 'Neetho' ? neetho_login1 : neetho_login2}
                                    alt="Neetho"
                                    onClick={handleAppNameChange}
                                />
                                <GapView width="30px" />
                                <TopImage
                                    src={state.appName === 'Neene' ? neene_login1 : neene_login2}
                                    alt="Neene"
                                    onClick={handleAppNameChange}
                                />
                            </FlexWrapper>
                        </FlexWrapperCenter>
                        <GapView height="20px" />

                        <div>
                            {errorMessage && <CustomError error={errorMessage} />}
                            {!localStorage.getItem('isLoggedIn') && localStorage.getItem('authToken') !== '' ? <form onSubmit={loginWithCredentials}>
                                <div>
                                    <InputParent>
                                        <LoginInput
                                            type="email"
                                            name="email"
                                            value={state.email}
                                            placeholder="Email"
                                            onChange={handleInputChange}
                                            id="email"
                                            autoComplete="on"
                                        />
                                    </InputParent>
                                    <InputParent>
                                        <LoginInput
                                            type="password"
                                            name="password"
                                            placeholder="Password"
                                            value={state.password}
                                            onChange={handleInputChange}
                                            onKeyDown={handleCapsLockState}
                                            onKeyUp={handleCapsLockState}
                                            onFocus={handleCapsLockState}
                                            onBlur={() => setIsCapsLockOn(false)}
                                            id="password"
                                            autoComplete="off"
                                        />
                                    </InputParent>
                                    {isCapsLockOn && <CapsWarning>CAPS LOCK ON</CapsWarning>}
                                </div>
                                <div>
                                    <LoginButton>Login</LoginButton>
                                </div>
                            </form> :

                                <form onSubmit={handleOtpSubmit}>
                                    <div>
                                        <InputParent>
                                            <LoginInput
                                                type="password"
                                                name="otp"
                                                value={state.otp}
                                                placeholder="OTP"
                                                onChange={handleInputChange}
                                                id="otp"
                                                autoComplete="off"
                                            />
                                        </InputParent>
                                        <GapView height="20px" />
                                        <BaseButton className='marginLeft110'>Submit</BaseButton>
                                    </div>
                                </form>
                            }
                        </div>
                    </LoginWrapper>
                ) : null
            }
        </>
    );
}

export default Login;
